import api from './api';
import { Feedback, CreateFeedbackInput, FeedbackAggregate, AdminFeedbackOverview } from '../types/feedback.types';

export const feedbackService = {
  async submit(sessionId: string, data: CreateFeedbackInput): Promise<Feedback> {
    const response = await api.post(`/sessions/${sessionId}/feedback`, data);
    return response.data;
  },

  async getMyFeedback(sessionId: string): Promise<Feedback | null> {
    const response = await api.get(`/sessions/${sessionId}/feedback/mine`);
    return response.data;
  },

  async hasSubmitted(sessionId: string): Promise<{ submitted: boolean }> {
    const response = await api.get(`/sessions/${sessionId}/feedback/has-submitted`);
    return response.data;
  },

  async getAggregate(sessionId: string): Promise<FeedbackAggregate> {
    const response = await api.get(`/sessions/${sessionId}/feedback/aggregate`);
    return response.data;
  },

  async getAll(sessionId: string): Promise<Feedback[]> {
    const response = await api.get(`/sessions/${sessionId}/feedback`);
    return response.data;
  },

  async getAdminOverview(): Promise<AdminFeedbackOverview> {
    const response = await api.get('/admin/feedback/overview');
    return response.data;
  },
};
